module.exports = __webpack_public_path__ + "static/img/cert-brand-4.7304214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert-brand-4.png
// module id = jVJs
// module chunks = 1